export const GUEST_OPTIONS = [
    { label: "1 person", value: "1" },
    { label: "2 people", value: "2" },
    { label: "3 people", value: "3" },
    { label: "4 people", value: "4" },
    { label: "5 people", value: "5" },
    { label: "6 people", value: "6" },
    { label: "7 people", value: "7" },
];

export const OCCASION_OPTIONS = [
    { label: "Birthday", value: "birthday" },
    { label: "Engagement", value: "engagement" },
    { label: "Anniversary", value: "anniversary" },
];

export const Gender_OPTIONS = [
    { label: "Mr.", value: "Mr." },
    { label: "Ms.", value: "Ms." },
    { label: "N/A", value: "N/A" },
];
